




















import Vue from 'vue'
export default Vue.extend({
  methods: {
    onClickLi (page: string) {
      this.$emit('nav', page)
    }
  }
})
